import { render } from "./AuctionUI.vue?vue&type=template&id=2fc8428d"
import script from "./AuctionUI.vue?vue&type=script&lang=js"
export * from "./AuctionUI.vue?vue&type=script&lang=js"

import "./AuctionUI.vue?vue&type=style&index=0&id=2fc8428d&lang=css"

import exportComponent from "/tmp/build_4e4571bb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__